var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-none d-xl-flex flex-column h-100 pl-2 pr-5 container float-left",
    attrs: {
      "id": "large-container"
    }
  }, [_c('div', {
    staticClass: "spacer-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column flex-grow-1 align-items-start justify-content-between",
    attrs: {
      "id": "main"
    }
  }, [_c('ul', {
    staticClass: "mb-5"
  }, _vm._l((_vm.links), function(link) {
    return (_vm.shouldDisplay(link)) ? _c('li', {
      key: link.index,
      staticClass: "mb-3"
    }, [(_vm.allowClick(link)) ? _c('router-link', {
      staticClass: "text-decoration-none",
      attrs: {
        "to": link.route
      }
    }, [_c('b-icon', {
      staticClass: "icon text-white mr-1",
      attrs: {
        "icon": link.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "pl-0 link",
      class: {
        'link-active': _vm.isActive(link.route)
      }
    }, [_vm._v("\n            " + _vm._s(link.display) + "\n          ")])], 1) : _c('div', {
      staticClass: "pointer"
    }, [_c('b-icon', {
      staticClass: "icon text-white mr-1",
      attrs: {
        "icon": link.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "pl-0 link",
      class: {
        'link-active': _vm.isActive(link.route)
      }
    }, [_vm._v("\n            " + _vm._s(link.display) + "\n          ")])], 1)], 1) : _vm._e()
  }), 0), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.doLogout
    }
  }, [_c('b-icon', {
    staticClass: "icon text-white mr-1",
    attrs: {
      "icon": "door-open"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-0 link"
  }, [_vm._v("Logout")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "spacer-bottom"
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea623cc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Layout/Sidebar/LargeSidebar.vue
// module id = Fur1
// module chunks = 2